import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import Button from "../components/ui/Button";

const sections = [
    {
        num: 1,
        title: "Información que Recopilamos",
        intro: "Recopilamos información que proporcionas directamente al comprar entradas, incluyendo:",
        items: [
            "Nombre completo",
            "Dirección de correo electrónico",
            "Número de teléfono",
            "Información de pago (procesada de forma segura por Stripe o Redsys, según el método de pago elegido)",
        ],
    },
    {
        num: 2,
        title: "Cómo Usamos tu Información",
        items: [
            "Procesar tu compra y enviar confirmación de entrada",
            "Comunicarnos contigo sobre tu pedido",
            "Mejorar nuestros servicios y experiencia de usuario",
            "Cumplir con obligaciones legales",
            "Enviar comunicaciones de marketing (solo si lo autorizas)",
        ],
    },
    {
        num: 3,
        title: "Protección de Datos",
        content:
            "Implementamos medidas de seguridad física, electrónica y administrativas para proteger tu información personal. Toda información de pago se procesa a través de Stripe o Redsys, plataformas que cumplen con los estándares PCI-DSS.",
    },
    {
        num: 4,
        title: "Compartición de Información",
        intro: "No vendemos, alquilamos ni compartimos tu información personal con terceros, excepto cuando es necesario para:",
        items: [
            "Procesar pagos (Stripe o Redsys)",
            "Cumplir con la ley",
            "Entregar tus entradas",
        ],
    },
    {
        num: 5,
        title: "Cookies",
        content:
            "Este sitio utiliza exclusivamente cookies técnicas y necesarias para el funcionamiento de la compra (por ejemplo, mantener la sesión y el carrito). No utilizamos cookies de analítica, publicidad ni personalización no esencial. Puedes configurar o bloquear cookies desde tu navegador, aunque algunas funciones básicas podrían dejar de funcionar correctamente.",
        link: {
            to: "/terms",
            text: "Consulta también los Términos y Condiciones.",
        },
    },
    {
        num: 6,
        title: "Tus Derechos",
        content:
            "Tienes derecho a acceder, corregir o eliminar tu información personal. Para ejercer estos derechos, contáctanos en entradas@pulseticket.es",
    },
    {
        num: 7,
        title: "Cambios en la Política",
        content:
            "Nos reservamos el derecho de actualizar esta política en cualquier momento. Te notificaremos sobre cambios significativos enviando un aviso a tu correo electrónico.",
    },
];

export default function PrivacyPage() {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.3 }}
            className="max-w-4xl mx-auto px-4 py-8"
        >
            <div className="mb-8">
                <Link to="/">
                    <Button variant="ghost" size="sm" icon={FiArrowLeft}>
                        Volver
                    </Button>
                </Link>
            </div>

            <div className="mb-10">
                <h1 className="text-4xl font-display font-bold text-white mb-2">
                    Política de Privacidad
                </h1>
                <p className="text-slate-400">
                    Última actualización: Marzo 2026
                </p>
            </div>

            <div className="space-y-4">
                {sections.map((section, idx) => (
                    <motion.section
                        key={section.num}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.05 }}
                        className="bg-slate-800/60 backdrop-blur-sm border border-slate-700/50 rounded-lg p-6 hover:shadow-md transition"
                    >
                        <div className="flex items-start gap-4 mb-4">
                            <div className="flex-shrink-0 w-10 h-10 bg-primary-500/20 text-primary-400 rounded-lg flex items-center justify-center font-bold text-lg">
                                {section.num}
                            </div>
                            <h2 className="text-lg font-bold text-white">
                                {section.title}
                            </h2>
                        </div>

                        {section.intro && (
                            <p className="text-slate-400 leading-relaxed ml-14 mb-3">
                                {section.intro}
                            </p>
                        )}

                        {section.content && (
                            <p className="text-slate-400 leading-relaxed ml-14">
                                {section.content}
                            </p>
                        )}

                        {section.link && (
                            <p className="text-slate-400 leading-relaxed ml-14 mt-2">
                                <Link
                                    to={section.link.to}
                                    className="text-primary-400 hover:underline font-semibold"
                                >
                                    {section.link.text}
                                </Link>
                            </p>
                        )}

                        {section.items && (
                            <ul className="list-disc list-inside text-slate-400 space-y-2 ml-4">
                                {section.items.map((item, i) => (
                                    <li key={i}>{item}</li>
                                ))}
                            </ul>
                        )}
                    </motion.section>
                ))}
            </div>

            <div className="mt-12 pt-8 border-t border-slate-700/50">
                <p className="text-slate-400 text-sm">
                    <span className="font-semibold">Última actualización:</span>{" "}
                    {new Date().toLocaleDateString("es-ES")}
                </p>
                <p className="text-slate-400 text-sm mt-3">
                    Para más información, contáctanos en{" "}
                    <a
                        href="mailto:entradas@pulseticket.es"
                        className="text-primary-400 hover:underline font-semibold"
                    >
                        entradas@pulseticket.es
                    </a>
                </p>
            </div>
        </motion.div>
    );
}
